import React from 'react';
import { Wrapper, Current } from './style';
import { IProgress } from './types';

const Line = function(props: IProgress) {
    const { current, ...rest } = props;
    return (
        <Wrapper {...rest}>
            <Current {...rest} className="progressBar" percent={current} />
        </Wrapper>
    );
};
Line.defaultProps = {
    width: 100,
    height: 3,
};
export default Line;
